import React, { useState } from "react";
import RightComponent from "./RightComponent";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useSearchParams } from "react-router-dom";

const RightSide = () => {
  let [searchParams] = useSearchParams();

  const code = sessionStorage.getItem("code");

  const decoded = jwt_decode(code);
  // console.log(decoded.jwttoken);

  const shopname =decoded.jwttoken;

  const url = "/addUpdate";

  const [user, setUser] = useState({
    shopify_domain: shopname,
    firsttext: "",
    secondtext: "",
    icon: "",
    faviconUrl: "",
    enable: false,
  });

  const [value1, setValue1] = useState("");
  const [value2, setValue2] = useState("");
  const [checked, setChecked] = useState(false);
  const [urlvalue, setUrlValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("user =>", user);
    axios.post(url, {
      enable:user.enable,
      shopify_domain:shopname,
      firsttext: user.firsttext,
      secondtext: user.secondtext,
      icon: user.icon,
      faviconUrl:user.faviconUrl
      // faviconUrl: user.faviconUrl,
      // secondtextEmoji: user.secondtextEmoji,
      // firsttextEmoji: user.firsttextEmoji,
    })
    .then(res=>{
      // console.log("right side===>>>",res.user);

    })
    // console.log(user);
    // console.log(checked);
    // console.log("botton===>>>",user.enable);
  };

  return (
    <React.Fragment>
      <RightComponent
        arg={{
          user,
          setUser,
          handleSubmit,
          value1,
          setValue1,
          value2,
          setValue2,
          urlvalue,
          setUrlValue,
          checked,
          setChecked,
        }}
      />
    </React.Fragment>
  );
};

export default RightSide;
